// src/services/feedbackConsole.js
import {reactive} from 'vue';

/*
 * The feedback console's open state, kept outside the components so the button
 * in the corner and the console it opens are not required to be the same tree.
 */
const state = reactive({
    open: false,
});


export const feedbackConsole = {
    state,
    get isOpen() {
        return state.open;
    },
    open() {
        state.open = true;
    },
    close() {
        state.open = false;
    },
    toggle() {
        state.open = !state.open;
    },
};

export default feedbackConsole;
